import React, { useState, useEffect } from 'react';
import { api } from '../services/api';

export default function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get('token');
  const [status, setStatus]     = useState('loading'); // loading | valid | invalid | success
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  useEffect(() => {
    if (!token) { setStatus('invalid'); return; }
    api.validateToken(token)
      .then(d => setStatus(d.valid && d.type === 'password' ? 'valid' : 'invalid'))
      .catch(() => setStatus('invalid'));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) return setError('Passwords don\'t match.');
    if (password.length < 6) return setError('Password must be at least 6 characters.');
    setLoading(true);
    try {
      await api.resetPassword(token, password);
      setStatus('success');
    } catch (err) {
      setError(err.message || 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position:'fixed', inset:0, overflowY:'auto', background:'#0f172a',
      backgroundImage:'radial-gradient(ellipse 80% 60% at 50% 0%,rgba(79,70,229,.22) 0%,transparent 65%)',
      fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif' }}>

      <nav style={{ height:64, padding:'0 5%', display:'flex', alignItems:'center',
        borderBottom:'1px solid rgba(255,255,255,.06)' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ width:34, height:34, borderRadius:9, overflow:'hidden' }}>
            <img src="/icon-192.png" alt="Seva" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
          </div>
          <span style={{ fontSize:18, fontWeight:800, color:'#f1f5f9', letterSpacing:'-0.3px' }}>Seva</span>
        </div>
      </nav>

      <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
        minHeight:'calc(100vh - 64px)', padding:'40px 5%' }}>
        <div style={{ width:420, padding:'40px 44px', background:'#fff',
          borderRadius:22, boxShadow:'0 40px 80px rgba(0,0,0,.45)' }}>

          {status === 'loading' && (
            <p style={{ textAlign:'center', color:'#64748b', fontSize:14 }}>Verifying link…</p>
          )}

          {status === 'invalid' && (
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:40, marginBottom:16 }}>⚠️</div>
              <h2 style={{ fontSize:20, fontWeight:800, color:'#0f172a', margin:'0 0 10px' }}>Link expired or invalid</h2>
              <p style={{ fontSize:14, color:'#64748b', lineHeight:1.6, margin:'0 0 24px' }}>
                This password reset link has expired or already been used. Please request a new one.
              </p>
              <a href="/" style={{ display:'block', background:'#4f46e5', color:'#fff', textDecoration:'none',
                borderRadius:10, padding:'13px', fontSize:15, fontWeight:700, textAlign:'center' }}>
                Back to sign in
              </a>
            </div>
          )}

          {status === 'valid' && (
            <>
              <div style={{ textAlign:'center', marginBottom:28 }}>
                <h1 style={{ fontSize:22, fontWeight:800, color:'#0f172a', margin:'0 0 8px' }}>Set a new password</h1>
                <p style={{ fontSize:14, color:'#64748b', margin:0 }}>Choose a strong password for your account.</p>
              </div>
              <form onSubmit={handleSubmit}>
                {error && (
                  <div style={{ background:'#fef2f2', color:'#dc2626', border:'1px solid #fecaca',
                    borderRadius:10, padding:'10px 14px', fontSize:13, marginBottom:16 }}>{error}</div>
                )}
                <div style={{ marginBottom:16 }}>
                  <label style={lbl}>New password</label>
                  <input style={inp} type="password" value={password}
                    onChange={e => setPassword(e.target.value)} required autoFocus />
                </div>
                <div style={{ marginBottom:24 }}>
                  <label style={lbl}>Confirm password</label>
                  <input style={inp} type="password" value={confirm}
                    onChange={e => setConfirm(e.target.value)} required />
                </div>
                <button type="submit" style={btnStyle} disabled={loading}>
                  {loading ? 'Saving…' : 'Save new password →'}
                </button>
              </form>
            </>
          )}

          {status === 'success' && (
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:40, marginBottom:16 }}>✅</div>
              <h2 style={{ fontSize:20, fontWeight:800, color:'#0f172a', margin:'0 0 10px' }}>Password updated</h2>
              <p style={{ fontSize:14, color:'#64748b', lineHeight:1.6, margin:'0 0 24px' }}>
                Your password has been changed. You can now sign in with your new password.
              </p>
              <a href="/" style={{ display:'block', background:'#4f46e5', color:'#fff', textDecoration:'none',
                borderRadius:10, padding:'13px', fontSize:15, fontWeight:700, textAlign:'center' }}>
                Sign in →
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const lbl = { display:'block', fontSize:11, fontWeight:700, color:'#64748b', marginBottom:6, textTransform:'uppercase', letterSpacing:'.06em' };
const inp = { width:'100%', background:'#f8fafc', border:'1.5px solid #e2e8f0', borderRadius:10, padding:'11px 14px', fontSize:14, color:'#0f172a', outline:'none', boxSizing:'border-box', fontFamily:'inherit' };
const btnStyle = { width:'100%', background:'#4f46e5', border:'none', borderRadius:10, padding:'13px', fontSize:15, fontWeight:700, color:'#fff', cursor:'pointer', boxShadow:'0 2px 12px rgba(79,70,229,.3)' };
